import { Component } from '@angular/core';

@Component({
  selector: 'cbs-till-operation-wrap-list',
  template: '<router-outlet></router-outlet>'
})

export class TillOperationWrapListComponent {
}
